import ListCentrosImpl from 'components/centros/ListCentrosImpl'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewCentros = () => {
  return (
    <Row>
        <Col>
          <ListCentrosImpl></ListCentrosImpl>
        </Col>
      </Row>
        
  )
}

export default ViewCentros